import { CheckoutMode } from '@afterpaytouch/portal-api/types'
import { useCheckoutMode, useCountry, useIsSupOrder } from '../../state'

export const useIsSupFlow = (): boolean => {
  const isSupOrder = useIsSupOrder()
  const checkoutMode = useCheckoutMode()
  const country = useCountry()
  return isSupOrder && checkoutMode !== CheckoutMode.EXPRESS && country === 'US'
}
